import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState('working');   // working | success | error
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setError('Missing unsubscribe token. Please use the link from the email.');
      return;
    }
    axios.post(`${API}/api/email/unsubscribe`, { token })
      .then(res => {
        setEmail(res.data?.email || '');
        setState('success');
      })
      .catch(err => {
        setError(err?.response?.data?.detail || 'We could not process this request. The link may be expired.');
        setState('error');
      });
  }, [token]);

  return (
    <div data-testid="unsubscribe-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F8FAFC', padding: 24, fontFamily: "'Inter',Helvetica,Arial,sans-serif" }}>
      <div style={{ width: '100%', maxWidth: 480, background: '#fff', border: '1px solid #E2E8F0', borderRadius: 14, padding: 36, boxShadow: '0 2px 20px rgba(15, 23, 42, 0.04)' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.12em', color: '#1E4E8C', textTransform: 'uppercase', marginBottom: 18 }}>Luminex</div>

        {state === 'working' && (
          <div data-testid="unsubscribe-working">
            <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 600, color: '#0F131C', margin: '0 0 12px' }}>Processing your request…</h1>
            <p style={{ fontSize: 13, color: '#64748B' }}>One moment while we update your preferences.</p>
          </div>
        )}

        {state === 'success' && (
          <div data-testid="unsubscribe-success">
            <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 600, color: '#0F131C', margin: '0 0 12px' }}>You're unsubscribed</h1>
            {email && <p style={{ fontSize: 13, color: '#475569', margin: '0 0 12px' }}><strong>{email}</strong> will no longer receive product-update or activation emails from Luminex.</p>}
            <p style={{ fontSize: 13, color: '#475569', margin: '0 0 12px' }}>You'll still receive <strong>transactional emails</strong> — order receipts, invoice PDFs, password resets — because those are necessary for using the platform.</p>
            <p style={{ fontSize: 12, color: '#94A3B8', margin: '24px 0 0' }}>Changed your mind? <a href="/settings#notifications" style={{ color: '#1E4E8C', fontWeight: 600, textDecoration: 'underline' }}>Re-enable emails in Settings →</a></p>
          </div>
        )}

        {state === 'error' && (
          <div data-testid="unsubscribe-error">
            <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 600, color: '#0F131C', margin: '0 0 12px' }}>Something went wrong</h1>
            <p style={{ fontSize: 13, color: '#DC2626', margin: '0 0 12px' }}>{error}</p>
            <p style={{ fontSize: 12, color: '#94A3B8', margin: '24px 0 0' }}>You can also unsubscribe from <a href="/settings#notifications" style={{ color: '#1E4E8C', fontWeight: 600, textDecoration: 'underline' }}>Settings → Notifications</a> after logging in.</p>
          </div>
        )}
      </div>
    </div>
  );
}
